export default __webpack_public_path__ + "static/media/facebook-login.04604fed.svg";